import React, { useCallback, useEffect, useRef, useState } from "react";
import TicketActions from "../../Actions/TicketActions";
import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import TicketConstants from "../../Constants/TicketConstants";
import ticketStore from "../../Stores/TicketStores";
import { useLanguageContext } from "../../Context/LanguageContext";
import { toast } from "react-toastify";
import TicketUpdateDialog from "./TicketUpdateDialog";
import TicketDetails from "./TicketDetails";
import { _helper } from "../GlobalFunction/dateHelper";
import CustomDataGrid from "../ReusableComponent/DataGrid/CustomizeDataGrid";
import { GrUpdate } from "react-icons/gr";
import { Button } from "@mui/material";
import { MdOutlinePreview } from "react-icons/md";
import { customizeFilter } from "../FilterOptions/CustomizeFilter";
import TicketFilterDropDown from "./TicketFilterDropDown";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { ColumneTypeDate } from "../ReusableComponent/DataGrid/ColumneTypeDate";
import equipmentGroupStore from "../../Stores/EquipmentGroupStore";
import EquipmentGroupContants from "../../Constants/EquipmentGroupConstants";
import EquipmentGroupActions from "../../Actions/EquipmentGroupActions";
export default function ManageTicket() {
  const { language, localization } = useLanguageContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const [responseData, setResponseData] = useState([]);
  const [tableData, setTableData] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [isBulkUpdate, setIsBulkUpdate] = useState(false);
  const [ticketDetails, setTicketDetails] = useState(false);
  const [selTicketId, setSelTicketId] = useState(null);
  const [state, setState] = React.useState("open");
  const [egList, setEgList] = useState([]);
  const [equipmentGroupId, setEquipmentGroupId] = useState("");
  const selectedEquipGrpId = useRef("");
  const columneNameTitle = [
    "ticketId",
    "ticketFor",
    "title",
    "ticketType",
    "description",
    "priority",
    "createdOn",
    "updatedOn",
    "closeReason",
    "category",
  ];
  const opertor = [
    { name: localization.equal, value: "equal" },
    { name: localization.contains, value: "contains" },
    { name: localization.startswith, value: "start with" },
    { name: localization.endWith, value: "end with" },
  ];
  const datePicker = [
    { name: "=", value: "=" },
    { name: ">", value: ">" },
    { name: ">=", value: ">=" },
    { name: "<", value: "<" },
    { name: "<=", value: "<=" },
  ];

  const columns = [
    {
      field: "ticketId",
      headerName: localization.ticketId,
      hideable: false,
      flex: 1,
    },
    {
      field: "actions",
      type: "actions",
      width: 45,
      hideable: false,
      headerName: localization.actions,
      getActions: (params) => [...getAction(params, localization)],
    },
    { field: "ticketFor", headerName: localization.ticketFor, flex: 1 },
    { field: "groupName", headerName: localization.equipmentGroup, flex: 1 },
    { field: "title", headerName: localization.manageTickeTitle, flex: 1 },
    { field: "ticketType", headerName: localization.ticketType, flex: 1 },
    {
      field: "description",
      headerName: localization.manageTicketDesc,
      flex: 1,
    },
    { field: "priority", headerName: localization.priority, flex: 1 },
    {
      ...ColumneTypeDate("createdOn", localization.createdOn, localization),
    },
    {
      ...ColumneTypeDate("updatedOn", localization.updatedOn, localization),
    },
    { field: "closeReason", headerName: localization.closeReason, flex: 1 },
    { field: "category", headerName: localization.category, flex: 1 },
  ];
  const getTicketByStatus = (_status) => {
    setGlobalSpinner(true);
    TicketActions.getAllTicket(_status, selectedEquipGrpId.current);
  };
  useEffect(() => {
    getTicketByStatus("open");
    function getActiveTicketSuccess() {
      var res = ticketStore.getResult();
      if (res.length > 0) {
        res.map((item) => {
          item["status"] =
            item["status"].toLowerCase() === "open"
              ? localization.open
              : item["status"].toLowerCase() === "close"
                ? localization.close
                : localization.inprogress;
          item["priority"] =
            item["priority"].toLowerCase() === "high"
              ? localization.high
              : item["priority"].toLowerCase() === "low"
                ? localization.low
                : localization.medium;
        });
        setTableData(res);
        setResponseData(res);
      } else {
        setTableData([]);
        setResponseData([]);
      }
      setGlobalSpinner(false);
    }
    function getActiveTicketFailure() {
      var res = ticketStore.getResult();
      setGlobalSpinner(false);
    }
    ticketStore.addChangeListener(
      TicketConstants.GET_TICKET_SUCCESS,
      getActiveTicketSuccess,
    );
    ticketStore.addChangeListener(
      TicketConstants.GET_TICKET_FAILURE,
      getActiveTicketFailure,
    );
    return () => {
      ticketStore.removeChangeListener(
        TicketConstants.GET_TICKET_SUCCESS,
        getActiveTicketSuccess,
      );
      ticketStore.removeChangeListener(
        TicketConstants.GET_TICKET_FAILURE,
        getActiveTicketFailure,
      );
    };
  }, []);

  useEffect(() => {
    function getSingleStatusUpdateSuccess() {
      getTicketByStatus(state);
      toast.success(localization.ticketUpdatedSuccess);
      setTableData(null);
      handleClose();
    }

    function getSingleStatusUpdateFailure() {
      var res = ticketStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    ticketStore.addChangeListener(
      TicketConstants.UPDATE_TICKET_STATUS_SUCCESS,
      getSingleStatusUpdateSuccess,
    );
    ticketStore.addChangeListener(
      TicketConstants.UPDATE_TICKET_STATUS_FAILURE,
      getSingleStatusUpdateFailure,
    );
    return () => {
      ticketStore.removeChangeListener(
        TicketConstants.UPDATE_TICKET_STATUS_SUCCESS,
        getSingleStatusUpdateSuccess,
      );
      ticketStore.removeChangeListener(
        TicketConstants.UPDATE_TICKET_STATUS_FAILURE,
        getSingleStatusUpdateFailure,
      );
    };
  }, [state]);

  useEffect(() => {
    function getBulkStatusUpdateSuccess() {
      getTicketByStatus(state);
      toast.success(localization.ticketUpdatedSuccess);
      handleClose();
      setTableData(null);
    }

    function getBulkStatusUpdateFailure() {
      var res = ticketStore.getResult();
      toast.error(res);
      setGlobalSpinner(false);
    }
    ticketStore.addChangeListener(
      TicketConstants.UPDATE_MUL_TICKET_STATUS_SUCCESS,
      getBulkStatusUpdateSuccess,
    );
    ticketStore.addChangeListener(
      TicketConstants.UPDATE_MUL_TICKET_STATUS_FAILURE,
      getBulkStatusUpdateFailure,
    );
    return () => {
      ticketStore.removeChangeListener(
        TicketConstants.UPDATE_MUL_TICKET_STATUS_SUCCESS,
        getBulkStatusUpdateSuccess,
      );
      ticketStore.removeChangeListener(
        TicketConstants.UPDATE_MUL_TICKET_STATUS_FAILURE,
        getBulkStatusUpdateFailure,
      );
    };
  }, [state]);

  function getEquipmentGroupByOrganisations() {
    EquipmentGroupActions.getManageTicketAnlagegruppes();
  }

  useEffect(() => {
    getEquipmentGroupByOrganisations();

    function getEquipmentGroupSuccess() {
      const res = equipmentGroupStore.getManageTicketEquipmentGrp();
      if (res.length > 0) {
        let sortList = res
          .filter((item) => item.roleId < 3 || item.roleId === 7)
          .sort((a, b) => (a.werk > b.werk ? 1 : a.werk < b.werk ? -1 : 0));
        setEgList(sortList);
      } else {
        setEgList([]);
      }
    }
    function getEquipmentGroupFailure() {
      setGlobalSpinner(false);
    }
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_MANAGE_TICKET_EQUIPMENT_GRP_SUCCESS,
      getEquipmentGroupSuccess,
    );
    equipmentGroupStore.addChangeListener(
      EquipmentGroupContants.GET_MANAGE_TICKET_EQUIPMENT_GRP_FAILURE,
      getEquipmentGroupFailure,
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_MANAGE_TICKET_EQUIPMENT_GRP_SUCCESS,
        getEquipmentGroupSuccess,
      );
      equipmentGroupStore.removeChangeListener(
        EquipmentGroupContants.GET_MANAGE_TICKET_EQUIPMENT_GRP_FAILURE,
        getEquipmentGroupFailure,
      );
    };
  }, []);

  function handleUpdateStatus(data) {
    if (Array.isArray(data)) {
      const _idList = data.map((item) => item.id);
      if (!isBulkUpdate) {
        setIsBulkUpdate(true);
      }
      setSelectedRow({ id: _idList, status: "Close" });
    } else {
      if (isBulkUpdate) {
        setIsBulkUpdate(false);
      }
      setSelectedRow({ id: data.id, status: data["status"] });
    }

    setOpenDialog(true);
  }

  function handleClose() {
    setOpenDialog(false);
  }

  function handleSubmitStatus(data) {
    selectedRow["status"] = data.status;
    selectedRow["reason"] = data.reason;
    if (isBulkUpdate) {
      setGlobalSpinner(true);
      TicketActions.UpdateBulkStatus(selectedRow);
    } else {
      setGlobalSpinner(true);
      TicketActions.UpdateStatus(selectedRow, false, language, false);
    }
  }

  function handleCloseDetails() {
    setTicketDetails(false);
  }

  function handleRowclick(row) {
    setSelTicketId(row.id);
    setTicketDetails(true);
  }

  useEffect(() => {
    selectedEquipGrpId.current = equipmentGroupId;
    getTicketByStatus(state);
    return () => {};
  }, [equipmentGroupId]);

  function RenderViewButton() {
    return (
      <>
        <Button
          variant="outlined"
          id="updateTicket"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<MdOutlinePreview />}
        >
          {localization.detailsTab}
        </Button>
      </>
    );
  }
  function RenderUpdateButton() {
    return (
      <>
        <Button
          variant="outlined"
          id="updateTicket"
          className="mr-4 svgIcon cursorPoint"
          startIcon={<GrUpdate />}
        >
          {localization.updatetooltip}
        </Button>
      </>
    );
  }
  const operations = {
    RowOperationList: [
      {
        label: "view",
        component: <RenderViewButton />,
        onClick: handleRowclick,
      },
      state !== "close" && {
        label: "Update",
        component: <RenderUpdateButton />,
        onClick: handleUpdateStatus,
      },
    ],
    GridToolBarAction: [],
    SelectedToolBar: [
      {
        label: "Update",
        component: <RenderUpdateButton />,
        onClick: handleUpdateStatus,
      },
    ],
  };

  const getTicketAfterUpdate = useCallback(() => {
    getTicketByStatus(state);
  }, [state]);

  function getAction(params) {
    const _acionList = [];
    _acionList.push(
      <GridActionsCellItem
        label={localization.detailsTab}
        showInMenu
        onClick={() => handleRowclick(params.row)}
      />,
    );
    if (!params["row"].status !== "close") {
      _acionList.push(
        <GridActionsCellItem
          label={localization.updatetooltip}
          showInMenu
          onClick={() => handleUpdateStatus(params.row)}
        />,
      );
    }
    return _acionList;
  }
  return (
    <>
      <div
        id="content"
        style={{ height: "100%", width: "100%", overflow: "auto" }}
      >
        {tableData && (
          <CustomDataGrid
            Title={localization.orgSetting + " / " + localization.tableTitle}
            renderParentComponent={
              <div className="form-group d-flex  align-items-center">
                <label htmlFor="equipmentGroupList" className="mr-3">
                  {localization.equipmentGroup}
                </label>
                <select
                  className="form-control"
                  id="equipmentGroupList"
                  name="equipmentGroupList"
                  value={equipmentGroupId}
                  onChange={(e) => {
                    setEquipmentGroupId(e.target.value);
                  }}
                >
                  <option value="">{localization.all}</option>
                  {egList.map((row, index) => {
                    return (
                      <option key={index} value={row.id}>
                        {row.bezeichnungsDisplay}
                      </option>
                    );
                  })}
                </select>
              </div>
            }
            columns={columns}
            rows={tableData}
            operations={operations}
            onAdd={() => {}}
            showExport={true}
            showColumns={true}
            showFilters={true}
            showDensity={true}
            visibleColumns={[...columneNameTitle]}
            showCheckBox={state !== "close"}
            gridTableHeight={"dataGridLarge"}
            gridFilter={
              <TicketFilterDropDown
                state={state}
                setState={setState}
                handleDropDownChanges={getTicketByStatus}
              />
            }
          />
        )}
      </div>
      {ticketDetails && (
        <TicketDetails
          selTicketId={selTicketId}
          handleClose={handleCloseDetails}
          getTicketAfterUpdate={getTicketAfterUpdate}
          state={state}
        />
      )}
      {openDialog && (
        <TicketUpdateDialog
          handleClose={handleClose}
          handleSubmitStatus={handleSubmitStatus}
        />
      )}
    </>
  );
}
